module.exports = __webpack_public_path__ + "static/media/man.bb631537.jpg";